import React, {Fragment, useEffect, useRef, useState} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification, Switch, DatePicker, Popover, Divider, Tag, Upload
} from "antd";


import {API_BASE_URL, ASSET_BASE_URL} from "../../configs/AppConfig";


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class PdforImage extends React.Component {

    state = {
        image: true,
        finalUrl: null
    }

    async componentDidMount() {
        const url = this.props.url
        const extension = url.split(".").slice(-1)[0]

        //console.log(extension)
        if (extension.toLowerCase() == "pdf") {
            this.setState({image: false})
        }


        var req = await fetch(url, {method: "HEAD"})
        //console.log(req)

        if (req.status == 404) {
            const filename = url.split("/").slice(-1)[0]
            this.setState({finalUrl: API_BASE_URL + "/upload/tmp/" + filename})
        } else {
            this.setState({finalUrl: url})
        }

    }

    render() {
        //console.log(this.state)

        if (!this.state.finalUrl) {
            return null
        }

        if (this.state.image) {
            return <img src={this.state.finalUrl} style={{width: "80%", height: 500, objectFit: "contain"}}/>
        }

        return (
            <iframe src={"https://docs.google.com/viewer?embedded=true&url=" + this.state.finalUrl}
                    style={{width: "80%", height: 500}}/>
        )
    }

}

